import api from './api';
import { removeToken } from '../utils/auth';

export const authService = {
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  logout: async () => {
    try {
      // Try to call logout endpoint, but don't fail if it doesn't work
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout API call failed:', error);
    } finally {
      // Always remove token locally
      removeToken();
    }
    return { message: 'Logged out successfully' };
  },

  verifyToken: async () => {
    try {
      const response = await api.get('/auth/verify');
      return response.data;
    } catch (error) {
      // If token verification fails, remove invalid token
      removeToken();
      throw error;
    }
  },

  getCurrentUser: async () => {
    // ✅ With httpOnly cookie, server automatically receives it in request
    const response = await api.get('/users/verify/current');
    return response.data;
  },

  checkAuthStatus: async () => {
    console.log('🔍 [AUTH_SERVICE] Checking authentication status...');

    try {
      // ✅ With httpOnly cookie, server automatically receives it in request
      // No need to check client-side - just make the API call
      console.log('📡 [AUTH_SERVICE] Making API request to get user /users/verify/current...');
      const response = await api.get('/users/verify/current');

      console.log('🔍 [AUTH_SERVICE] API response:', {
        message: response.data.message,
        hasUserData: !!(response.data.id && response.data.name)
      });

      if (response.data.message === 'Success') {
        const userData = {
          id: response.data.id,
          name: response.data.name,
          email: response.data.email,
          full_name: response.data.full_name,
          role: response.data.role
        };

        console.log('✅ [AUTH_SERVICE] User authentication successful');
        console.log('👤 [AUTH_SERVICE] User data retrieved:', userData);

        return {
          authenticated: true,
          user: userData
        };
      } else {
        console.log('❌ [AUTH_SERVICE] API returned unsuccessful response');
        return { authenticated: false, user: null };
      }
    } catch (error) {
      console.error('❌ [AUTH_SERVICE] API request failed:', error.message);
      return { authenticated: false, user: null };
    }
  }
};